import { render, staticRenderFns } from "./TipoArmamentoPage.vue?vue&type=template&id=cd24834e"
import script from "./TipoArmamentoPage.js?vue&type=script&lang=js&external"
export * from "./TipoArmamentoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports